
import { MapLocation } from '@/types/location';

// DownTown Gym Locations
export const downTownGyms: MapLocation[] = [
  {
    id: 16001,
    name: "DownTown Gym - Dammam (Al Khobar)",
    type: "Gym",
    devices: 2,
    coordinates: [26.282485962292363, 50.20819451753476],
    region: "Eastern",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "18-50",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
